import React from 'react';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import styles from "./styles.scss";

const DiningBanner = props => {
  const { height, isMobile } = useViewport();
  const animationClasses = ['animate-height', 'animate-width'];
  const {
    title,
    description,
    description_mobile,
    image,
    image_mobile,
    thumbnail,
    thumbnail_mobile,
    banner_video,
  } = props.data;
  const { theme } = props;
  const countLengthOf = StringUtil.sliceHtml(description);
  const descriptionMobile = StringUtil.sliceHtml(description_mobile);
  const length = words(countLengthOf).length;

  const renderDescription = () => {
    if (isMobile) {
      return (
        <h3 className={'restaurant-mobile-description'}>{descriptionMobile}</h3>
      );
    }
    return (
      <HTMLView
        className={'restaurant-description'}
        html={description}
        tagName={'div'}
      />
    );
  };

  const renderBannerTextMobile = () => {
    return (
      <div className={'banner-text'}>
        <h1>{title}</h1>
        {renderDescription()}
      </div>
    );
  };

  let className = 'restaurant-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;
  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    thumbNail = thumbnail_mobile;
    bannerText = renderBannerTextMobile();
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
        length={length}
        containerClassName={'restaurant-banner-image'}
        bannerImage={animationClasses.join(' ')}
        description={renderDescription()}
        descriptionClass={'restaurant-banner-description'}
      />
      {isMobile && (
        <FooterExploreButton
          theme={theme}
          sectionName={'restaurants-network'}
        />
      )}
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
    </div>
  );
};

export default DiningBanner;
